import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import NumberFormat from 'react-number-format';

import { numberFormat } from 'constants/formats';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import NotarySection from 'modules/_shared/components/NotarySection';
import InputTextArea from 'modules/_shared/components/InputTextArea';
import UploadDocument from 'modules/documents/components/UploadDocument';
import InputDate from 'modules/_shared/components/InputDate';

import { useCanjeModal } from '../context/CanjeModalContext';

const CanjeScriptureView: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useCanjeModal();

  return (
    <>
      <InputDate
        id="canje-date"
        label={t('Date')}
        value={data.date || ''}
        onChange={actions.handleChangeDate}
        minDate={data.lastOperationDate}
        errorMessageKey="InvalidOperationDate"
        required
        lgSize
      />

      <div className="form-group">
        <label className="form-label" htmlFor="canje-ratio-old">
          {t('ExchangeSharesPerBatch')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <NumberFormat
            id="canje-ratio-old"
            className="form-control form-control-lg"
            placeholder={t('ExchangeSharesPerBatch')}
            value={data.ratioOld || ''}
            onChange={actions.handleChangeRatioOld}
            required
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...numberFormat}
          />
        </div>
        <span className="form-label text-primary">
          {t('TotalParticipationsAvaila', {
            societyShares: data.societyActualShares,
          })}
        </span>
      </div>

      <UploadDocument
        label="AddDocumentOptional"
        inputLabel={data.file?.name || t('DragDocumentToUpload')}
        file={data.file}
        setFile={actions.handleChangeFile}
      />

      <InputTextArea
        id="canje-comments"
        label={t('CommentsLabel')}
        value={data.comments}
        onChange={actions.handleChangeComments}
        noResize
      />

      <div className="row mb-4">
        <NotarySection
          notaryName={data.notaryName}
          onChangeName={actions.handleChangeNotaryName}
          notaryProtocol={data.notaryProtocol}
          onChangeProtocol={actions.handleChangeNotaryProtocol}
          notaryCity={data.notaryCity}
          onChangeCity={actions.handleChangeNotaryCity}
          lgSize
        />
      </div>
    </>
  );
};

export default CanjeScriptureView;
